"use client";

import dynamic from "next/dynamic";

// `loading` gives each its own Suspense boundary; without it, a chunk still
// loading at hydration holds back the boundary around `main`, which re-renders.
const noFallback = () => null;

/** Split out so customers, who never render them, never download the dev console. */
export const DevPanels = dynamic(
	() => import("./dev-tools").then((mod) => mod.DevPanels),
	{ loading: noFallback }
);

export const DevStatePreviewOverlay = dynamic(
	() => import("./dev-tools").then((mod) => mod.DevStatePreviewOverlay),
	{ loading: noFallback }
);
